import * as Yup from "yup";
import { UserFragment } from "~graphql/sdk";

export interface SavedFormValues {
  email?: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  usableForMarketing?: boolean;
}

export const initialValues = (
  user?: UserFragment,
  savedFormValues?: SavedFormValues
) => ({
  email: savedFormValues?.email ?? user?.email ?? "",
  phoneNumber: savedFormValues?.phoneNumber ?? user?.phoneNumber ?? "",
  firstName: savedFormValues?.firstName ?? user?.firstName ?? "",
  lastName: savedFormValues?.lastName ?? user?.lastName ?? "",
  usableForMarketing: user
    ? !!(user.usableForEmailMarketing || user.usableForSMSMarketing)
    : true,
});

export const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "First name must be at least 2 characters")
    .required("First name is required"),
  lastName: Yup.string()
    .min(2, "Last name must be at least 2 characters")
    .required("Last name is required"),
  email: Yup.string().email().required("Email is required"),
  phoneNumber: Yup.string()
    .matches(/^\+?\d+( \d+)*$/, "Invalid phone number")
    .required("Phone number is required"),
  usableForMarketing: Yup.boolean().required(),
});
